class LinksUteisHandle {

    formToJso(formData) {
        return {
            id: formData.id,
            titulo: formData.titulo,
            url: formData.url,
            status: formData.status,
        };
    }

}

export default new LinksUteisHandle();